import _ from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import StoreCardItem from '../components/StoreCardItem'

import sortedByDistanceMatrix from '../helpers/sortedByDistanceMatrix'
import useStore from '../hooks/useStore'
import { LatLng, StoreItem } from '../types'

const ITEM_PER_PAGE = 4

const _useMemo = useMemo

export const SidebarContainer = () => {
  const [
    { currentPosition, stores, yourStore, searchPosition },
    { setAsStore, getStoreSorted },
  ] = useStore()

  const defaultStores = stores

  const [paging, setPaging] = useState({
    currentPage: 0,
    hasNextPage: true,
  })
  const [listedStores, setListedStore] = useState<StoreItem[]>([])

  const chunkStores = currentPosition
    ? _useMemo(() => _.chunk(defaultStores, ITEM_PER_PAGE), [stores])
    : _useMemo(
        () =>
          _.chunk(
            stores.sort((a, b) =>
              a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            ),
            ITEM_PER_PAGE
          ),
        [stores]
      )

  const getStored = async (stores: StoreItem[], position: LatLng) => {
    const sortedStores = await sortedByDistanceMatrix(stores, position)
    if (!sortedStores || sortedStores?.length === 0) return
    getStoreSorted(sortedStores as StoreItem[])
  }

  // Get data sorted by distances
  useEffect(() => {
    if (!currentPosition) return
    getStored(stores, currentPosition)
  }, [currentPosition])

  // Initialize data
  useEffect(() => {
    if (paging.currentPage !== 0) return

    if (chunkStores && chunkStores.length > 0) {
      setListedStore(chunkStores[paging.currentPage])
    }
  }, [chunkStores])

  // Update paging
  useEffect(() => {
    const chunkStore = chunkStores[paging.currentPage]
    setListedStore((prev) => prev?.concat(chunkStore))
  }, [paging])

  const handleSetStore = (store: StoreItem) => setAsStore(store)

  const handleLoadMore = () =>
    setPaging((prev) => ({
      ...prev,
      currentPage: prev.currentPage + 1,
    }))

  const shouldLoadMore = chunkStores.length - 1 > paging.currentPage

  return (
    <div className="flex flex-col mt-4">
      {searchPosition && (
        <div className="my-4 text-14">
          {`Showing stores near ${searchPosition}`}
        </div>
      )}
      {yourStore && (
        <>
          <div className="flex flex-col">
            <StoreCardItem {...yourStore} isLocalStore />
            <div
              className="bg-gray-100 mt-4 mb-4"
              style={{
                height: '0.5px',
              }}
            />
          </div>
        </>
      )}
      {listedStores
        ?.filter((s) => (yourStore ? s?.id !== yourStore?.id : s))
        .map((store, k) => (
          <div key={k}>
            <StoreCardItem
              {...store}
              isLocalStore={(yourStore && yourStore?.id === store?.id) || false}
              onSetStore={() => handleSetStore(store)}
            />
            <div
              className="bg-gray-100 my-2"
              style={{
                height: '0.5px',
              }}
            />
          </div>
        ))}
      <div className="pb-16 w-full">
        {shouldLoadMore && (
          <button onClick={() => handleLoadMore()}>More Stores</button>
        )}
      </div>
    </div>
  )
}
